export default "__VITE_ASSET__BYs_rJ0g__"